import type { DocumentId } from 'core/types';
import { documentsActions } from 'core/store';
import { useNavigate } from 'react-router';
import { useDispatch } from 'react-redux';

export const useNavigateWithExpand = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (documentId: DocumentId) => {
    dispatch(documentsActions.getDocument(documentId));
    dispatch(
      documentsActions.expandParents({
        documentId,
        onSuccess: () => {
          navigate(`/${documentId}`);
        },
      }),
    );
  };
};
